import React, {Component} from "react";
import {Var} from "../../../App";
import PropTypes from "prop-types";
import Resource from "../../../Resource";
import './index.css'
import {withRouter} from "react-router-dom";

class Button extends Component {
    constructor(props) {
        super(props);
        props.refer.current = this;


        this.state = {
            disabled: false,
            loading: false,
            id: `inp_${Var.shuffle('string', 6)}`
        };

        this.ref = {
            button: React.createRef()
        };
    }

    static defaultProps = {
        theme: null,
        align: 'center',
        iconAlign: 'right',
        children: null,
        id: `button_${Var.shuffle('string', 6)}`,
        disabled: false,
        icon: null,
        loaderColor: '#555',
        className: null,
        link: null,
        refer: {current: null},
        onClick: _ => null
    };

    static propTypes = {
        theme: PropTypes.oneOf(['red', 'yellow', 'blue', 'green', 'gray']),
        align: PropTypes.oneOf(['left', 'center', 'right']),
        iconAlign: PropTypes.oneOf(['left', 'right']),
        children: PropTypes.any,
        id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
        disabled: PropTypes.bool,
        icon: PropTypes.string,
        loaderColor: PropTypes.string,
        className: PropTypes.string,
        link: PropTypes.string,
        refer: PropTypes.object,
        onClick: PropTypes.func
    };

    componentDidMount() {

    }

    render() {
        const {state, props} = this;
        const classes = ['Button', this.props.align];
        const loading = state.loading || props.loading;
        const disabled = state.disabled || props.disabled || loading;
        const id = props.id || state.id;

        props.className && classes.push(props.className);
        props.icon && classes.push(`icon icon-${props.iconAlign}`);
        (loading && !props.icon) && classes.push('loading');
        disabled && classes.push('disabled');
        props.theme && classes.push(`theme-${props.theme}`);

        return <button ref={this.ref.button}
                       className={classes.join(' ')}
                       id={id}
                       disabled={disabled}
                       onClick={this.buttonClickHandler.bind(this)}>
            {props.icon && <div className="Button-icon"><img src={loading ? Resource.IMAGE.LOADER : props.icon} alt=""/></div>}
            <span className={'Button-content'}>{props.children}</span>
        </button>;
    };

    disabled(disabled = true) {
        this.setState({disabled});
    }

    loading(loading = true) {
        this.setState({loading});
    }

    focus() {
        this.ref.button.current.focus();
    }

    buttonClickHandler(event) {
        const {props} = this;

        if (props.link)
            props.history.push(props.link);

        props.onClick(event);
    }
}

export default withRouter(Button);